(function () {
    const header = document.querySelector('.nav-glass');
    const pills = document.getElementById('sections-gallery');
    const more = document.getElementById('more-menu');
    const drop = document.getElementById('more-dropdown');

    // Sombra al scrollear
    const onScroll = () => {
        if (!header) return;
        if (window.scrollY > 4) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Overflow → mover a "Más"
    function redistribute() {
        if (!pills || !more || !drop) return;
        // Devolver todo al carril principal antes de medir
        [...drop.children].forEach(a => pills.appendChild(a));

        const available = pills.clientWidth - 50; // deja espacio para botón "Más"
        let used = 0;
        const keep = [];
        const move = [];
        [...pills.children].forEach(el => {
            if (!(el instanceof HTMLAnchorElement)) return;
            const w = el.getBoundingClientRect().width + 8; // gap
            if (used + w <= available) { keep.push(el); used += w; }
            else { move.push(el); }
        });

        move.forEach(el => drop.appendChild(el));
        more.classList.toggle('open', move.length === 0 ? false : more.classList.contains('open'));
        more.style.display = move.length ? 'block' : 'none';

        document.dispatchEvent(new CustomEvent("bc:sections-updated"));
    }
    window.addEventListener('resize', () => requestAnimationFrame(redistribute));
    document.addEventListener('DOMContentLoaded', redistribute);
    setTimeout(redistribute, 0);

    // Toggle del dropdown (mejor para mobile que :hover)
    if (more) {
        more.addEventListener('click', (e) => {
            e.stopPropagation();
            more.classList.toggle('open');
        });
        document.addEventListener('click', () => more.classList.remove('open'));
    }
})();
